<template>
  <Splitpanes
    class="default-theme panel__group"
  >
    <Pane
      class="panel__left  scroll-y"
      size="25"
    >
      <nav v-if="showTopNav">
        <Logo v-if="comingFromExternal" />
        <NavSplitMain
          :previous-route="previousRoute"
          :show-stop-geoloc="showStopGeoloc"
          :show-go-back-map="showGoBackMap"
        />
      </nav>
      <main class="mainContent">
        <slot name="left" />
        <div class="flex justify-end mt-auto px-3">
          <ButtonReportProblem
            v-if="showReportProblem"
            class="inline-block py-3"
            @toggle-visible="problemModalVisible = ! problemModalVisible"
          />
        </div>
      </main>
    </Pane>
    <Pane
      size="75"
      class="panel__right"
    >
      <router-view>
        <keep-alive>
          <UserNavAccount
            v-if="showAccount"
            class="layoutSplit__account"
          />
        </keep-alive>
      </router-view>
      <slot name="right" />
    </Pane>
    <slot name="modals" />
    <ModalReportProblem
      v-if="showReportProblem"
      v-model:modal-visible="problemModalVisible"
    />
  </Splitpanes>
</template>

<script>
import { Splitpanes, Pane } from 'splitpanes';
import ButtonReportProblem from '@/components/common/ButtonReportProblem';
import Logo from '@/components/common/Logo';
import ModalReportProblem from '@/components/common/ModalReportProblem';
import UserNavAccount from '@/components/user/UserNavAccount';
import NavSplitMain from '@/components/common/NavSplitMain';

import { mapGetters } from 'vuex';

export default {
  name: 'LayoutSplit',

  components: {
    Logo,
    NavSplitMain,
    UserNavAccount,
    ButtonReportProblem,
    ModalReportProblem,
    Splitpanes,
    Pane
  },

  props: {
    showAccount: {
      type: Boolean,
      default: () => true
    },

    showReportProblem: {
      type: Boolean,
      default: () => false
    },

    showTopNav: {
      type: Boolean,
      default: () => true
    },

    previousRoute: {
      type: Object,
      default: () => ({ name: null })
    },

    showStopGeoloc: {
      type: Boolean,
      default: () => false
    },

    showGoBackMap: {
      type: Boolean,
      default: () => false
    },

  },


  data() {
    return {
      problemModalVisible: false
    };
  },

  computed: {
    ...mapGetters('app', ['comingFromExternal'])
  }
};
</script>

<style lang="postcss">
.layoutSplit__account{
  @apply absolute right-0 h-16 flex flex-shrink-0 items-center bg-white shadow z-30 pl-4;
}

.panel__group{
  @apply flex h-full w-full;
}

.mainContent > *:not(.separator):not(.no-margin) {
  @apply pl-8 pr-6;
}

.panel__left{
  @apply  z-20 relative overflow-y-auto shadow-lg flex flex-col h-full;
  min-width:400px;
  max-width:50vw;
}

.panel__left > nav{
  @apply flex h-16 justify-between items-center border-gray-100 border-b border-solid;
  min-height: 4rem;
}

.panel__right{
  @apply flex-grow;
}

.mainContent{
  @apply flex flex-col flex-grow;
}

.slider--open .panel__left {
  height: calc(100% - var(--sliderHeight));
}

@media screen and (max-width:1200px) {
  .panel__left{
    width:400px;
  }
}

@media screen and (max-width:900px) {
  .panel__group{
    flex-direction:column !important;
    overflow:hidden;
  }
  .panel__left,
  .panel__right{
    @apply w-full max-w-full;
    width: 100% !important;
  }
  .panel__right{
    @apply h-full;
  }
  .panel__left{
    order:1;
  }
  .mainContent{
    width:100vw;
  }
  .panel__group,
  .slider--open .panel__left,
  .slider--open .panel__right
  .slider--open #cesiumContainer {
    height: auto;
  }

  #viewerOSD,
  .openseadragon-container,
  .openseadragon-canvas,
  .openseadragon-canvas canvas,
  .cesium-viewer canvas{
    min-height:100vw;
  }
  .layoutSplit__account,
  .panel__group~.slider__group{
    @apply hidden;
  }
}
</style>
